import { Box, Stack, Tooltip } from '@mui/material';
import { AssortmentTagChip } from './AssortmentTagChip';
import { SupplierItemAssortmentTag } from '@retail/products/types';
import { AssortmentTagTooltipInfo } from './AssortmentTagTooltipInfo';

interface Props {
  assortmentTags: SupplierItemAssortmentTag[];
}

export const AssortmentTagChips = ({ assortmentTags }: Props) => {
  return (
    <Box width="100%" display="flex" flexWrap="wrap" gap={1}>
      {assortmentTags.map((tag) => (
        <Tooltip key={tag.tagId} title={<AssortmentTagTooltipInfo assortmentTag={tag} />} arrow>
          <Stack>
            <AssortmentTagChip tagName={tag.tagName ?? String(tag.tagId)} />
          </Stack>
        </Tooltip>
      ))}
    </Box>
  );
};
